import React, { useState } from 'react';
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito saber programar o tener experiencia técnica?',
    a: 'Cero. Si puedes escribir en WhatsApp, puedes usar las herramientas del sistema. El método está diseñado para que el lenguaje natural sea tu único "código". Nadie toca una línea de programación real.'
  }, {
    q: '¿Esto funciona si vivo fuera de Latinoamérica?',
    a: 'El método es 100% global. Las herramientas funcionan en cualquier idioma y para cualquier mercado. El ebook está en español pero la estrategia de monetización aplica para clientes en cualquier continente.'
  }, {
    q: '¿Cuánto tengo que invertir en herramientas adicionales?',
    a: 'El sistema comienza con las versiones gratuitas de todas las herramientas. Solo escala a planes de pago cuando ya estés generando ingresos con tus primeros contratos. La inversión inicial real es solo el precio de este ebook.'
  }, {
    q: '¿Cuándo y cómo recibo el ebook después de pagar?',
    a: 'Acceso inmediato. En menos de 2 minutos después de confirmar tu pago recibirás el link de descarga directamente. Sin esperas. Sin intermediarios. Acceso permanente desde cualquier dispositivo.'
  }, {
    q: '¿Cómo consigo mis primeros clientes sin tener portafolio?',
    a: 'El Módulo 5 cubre exactamente esto. Te damos los scripts de prospección para contactar negocios locales e internacionales, cómo construir tu portafolio de muestra en 48 horas con IA, y cómo posicionarte como experto desde el día 1.'
  }];
  return <section className="py-8 md:py-[100px] px-4 md:px-12 relative z-10" aria-label="Preguntas frecuentes" data-id="element-53">
      <div className="max-w-[720px] mx-auto" data-id="element-54">
        <div className="text-center mb-6 md:mb-16" data-id="element-55">
          <span className="section-tag" data-id="element-56">Dudas Finales</span>
          <h2 className="font-display text-[clamp(1.8rem,4vw,4rem)] tracking-[3px] leading-none" data-id="element-57">
            LAS PREGUNTAS
            <br data-id="element-58" />
            QUE TIENES
          </h2>
        </div>
        <div className="flex flex-col gap-2 md:gap-3" role="list" data-id="element-59">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className={`bg-bg-card border rounded-xl overflow-hidden transition-all duration-[350ms] ${isOpen ? 'border-border-glow' : 'border-border'}`} role="listitem" data-id="element-60">
                <button className={`w-full text-left px-4 md:px-7 py-3.5 md:py-5 font-body text-[0.82rem] md:text-[0.95rem] font-semibold flex justify-between items-center select-none transition-colors ${isOpen ? 'text-gold' : 'text-white hover:text-gold'}`} onClick={() => setOpenIdx(isOpen ? null : idx)} aria-expanded={isOpen} data-id="element-61">
                  <span className="pr-3" data-id="element-62">{faq.q}</span>
                  <span className={`w-6 h-6 md:w-[26px] md:h-[26px] border border-border-glow rounded-full flex items-center justify-center text-[0.8rem] md:text-[0.9rem] shrink-0 transition-all duration-300 ${isOpen ? 'bg-gold text-black rotate-45' : 'text-gold'}`} aria-hidden="true" data-id="element-63">
                    +
                  </span>
                </button>
                <div className={`px-4 md:px-7 font-text text-[0.8rem] md:text-[0.9rem] text-text-silver leading-[1.7] overflow-hidden transition-all duration-[400ms] ${isOpen ? 'max-h-[300px] pb-4 md:pb-6 opacity-100' : 'max-h-0 pb-0 opacity-0'}`} data-id="element-64">
                  {faq.a}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}